import { Checkbox } from '@melements/front-components';
import { CheckboxGroup } from '@melements/front-components/dist/components/checkbox/checkboxGroup/CheckboxGroup';
import React, { useContext, useState } from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { Column, LocaleContext, Row } from 'shared';

import { AddNewLockFormLabel } from '../../AddNewLockForm.styles';

import { CheckboxWrapper } from './EndpointList.styles';
import { EndpointListTypes } from './EndpointList.types';

export const EndpointList = ({ endpoints }: EndpointListTypes) => {
  const localeContext = useContext(LocaleContext);
  const [endpointsMap, setEndpointsMap] = useState(
    endpoints ? endpoints.reduce((o, key) => ({ ...o, [key]: false }), {}) : {},
  );
  const [selectAllToggled, setSelectAllToggled] = useState(false);

  const selectAll = 'select all';

  const handleSelectAll = (onChange: any) => {
    const endpointsMapToggled = Object.assign({}, endpointsMap);
    Object.keys(endpointsMapToggled).forEach(v => (endpointsMapToggled[v] = !selectAllToggled));
    setSelectAllToggled(!selectAllToggled);
    setEndpointsMap(endpointsMapToggled);
    onChange(endpointsMapToggled);
  };

  const handleSelect = (endpoint: string, onChange: any) => {
    const endpointsMapToggled = Object.assign({}, endpointsMap);
    endpointsMapToggled[endpoint] = !endpointsMapToggled[endpoint];

    setEndpointsMap(endpointsMapToggled);
    onChange(endpointsMapToggled);
  };

  return (
    <Row>
      <Column size={[12]}>
        <AddNewLockFormLabel>
          {localeContext.formatMessage({ id: 'ENDPOINTS.FORM.ADD_NEW_LOCK.CHOOSE-ENDPOINTS' })}
        </AddNewLockFormLabel>
      </Column>
      <Column size={[12]}>
        <Field name="endpoints">
          {({ input, meta }: { meta: FieldRenderProps<any>['meta']; input: any }) => {
            const onChange = () => handleSelectAll(input.onChange);

            return (
              <CheckboxWrapper
                key={selectAll}
                label={selectAll.toUpperCase()}
                name={selectAll}
                input={{
                  ...input,
                  onChange,
                }}
                meta={meta}
              />
            );
          }}
        </Field>
        {endpoints && (
          <Field name="endpoints">
            {({ input, meta }: { meta: FieldRenderProps<any>['meta']; input: any }) => (
              <CheckboxGroup input={input}>
                {endpoints.map((endpoint, key) => {
                  const onChange = () => handleSelect(endpoint, input.onChange);

                  return (
                    <Checkbox
                      key={key}
                      label={endpoint}
                      name={endpoint}
                      input={{
                        ...input,
                        checked: endpointsMap[endpoint],
                        onChange,
                      }}
                      meta={meta}
                    />
                  );
                })}
              </CheckboxGroup>
            )}
          </Field>
        )}
      </Column>
    </Row>
  );
};
